import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { MaterialReactTable } from 'material-react-table'
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import { PAGES } from '../../Constants/CommonConstants';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import { getDate, userPicUrl } from '../../utils/Helper';
// import { CustomerGetAction, CustomerStatusAction } from '../../Redux/Action/CustomerAction';
import { CategoryDeleteAction, CategoryGetAction, CategoryStatusAction } from "../../Redux/Action/Category";
import defaultImage from '../../assets/images/fely.png'
import { DashboardRedirectionAction } from "../../Redux/Action/CommonAction";
import Swal from 'sweetalert2'
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { useIntl, FormattedMessage } from 'react-intl';



function Category() {
  const intl = useIntl();
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<any>([]);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(['ASC']);
  const categorylist = useSelector((state: any) => state.CategoryGetState);
  const categoryDeleteStatus = useSelector((state: any) => state.CategoryDeleteState);
  const categoryStatusChange = useSelector((state: any) => state.categoryStatusState);
  const DashboardRedirectionStatedata = useSelector((state: any) => state.DashboardRedirectionState)



  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [popupdata, setPopudata] = useState<any>({})
  const log_in = useSelector((state: any) => state.categoryStatusState)

  // Table Coulmns
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data?.status;

        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );
        query.columnFilters.push({ id: "status", value: userStatus })
        dispatch(DashboardRedirectionAction('RESET'));
        dispatch(CategoryDeleteAction('RESET'));

        await dispatch(CategoryGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    categoryDeleteStatus?.status,
    categoryStatusChange.loading
  ]);
  useEffect(() => {
    setData(categorylist?.data?.data?.rows);
    setRowCount(categorylist?.data?.data?.count);
  }, [categorylist?.data]);

  const handleStatuschange = (data: any) => {
    const senddata = {
      status_id: data.id,
      status: data.status == 0 ? 1 : 0
    }
    // console.log(senddata)
    dispatch(CategoryStatusAction(senddata))

  }

  const handledeleteCategory = async (e: any) => {
        Swal.fire({
            title: VALIDATION_MESSAGE?.ARE_YOU_SURE,
            text: VALIDATION_MESSAGE?.ARE_YOU_DELETE_ANY,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: intl.formatMessage({ id: 'no' }),
            confirmButtonText: intl.formatMessage({ id: 'yes' }),
        }).then(async (result) => {
            if (result.isConfirmed) {
                const data = {
                    category_id: e?.id,
                };
                dispatch(CategoryDeleteAction(data))
                // setLoading(true)
            }
        });

  
}

  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: intl.formatMessage({ id: 's_no' }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50
    },
    {
      accessorKey: 'name',
      header: intl.formatMessage({ id: 'name' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'image_details',
      header: intl.formatMessage({ id: 'image' }),
      accessorFn: (row: { image_details: any; }) => <img src={userPicUrl(row?.image_details?.file_path)} alt="image" width={"60px"} height={"60px"} />,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      header: intl.formatMessage({ id: 'status' }),
      size: 50,
      accessorFn: (row: { id: any, status: number }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <label className="switch">
              <input type="checkbox" checked={row.status == 1} onChange={() => handleStatuschange(row)} />
              <span className="slider round"></span>
            </label>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: intl.formatMessage({ id: 'created_at' }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'updated_at',
      header: intl.formatMessage({ id: 'updated_at' }),
      accessorFn: (row: { updated_at: any; }) => getDate(row.updated_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: 'action' }),
      size: 30,
      accessorFn: (row: { id: any , services_details:any }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`category-edit`}
                pageID={row?.id}
                showEdit={true}
                showView={false}
                showDelete={false}
              />
            </span>
          </ul>
          <ul style={{ listStyleType: "none", marginLeft: "-10px" }}>
            <span>
             <a className="btn btn-danger-delete text-white" onClick={()=>handledeleteCategory(row)} >
             <i className="fas fa-trash-alt" title={intl.formatMessage({ id: 'delete' })} /></a>
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  return (
    <Fragment>
      {loading|| log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title={intl.formatMessage({ id: 'category_management' })}
        breadcrumbs={{
          secLast: { 'link': '/category', 'name': intl.formatMessage({ id: 'category_management' }) },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <div className="row gy-3 mb-3">
          <div className="col-md-6 col-lg-4">
            <div className="input-group">
              <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
              <input 
              type='text' 
              className="form-control m-0" 
              placeholder={intl.formatMessage({ id: 'search_by_name' })} 
              onChange={(e) => setSearchValue(e.target.value.trim())} 
            />
            </div>
          </div>
          <div className="col-md-6 ms-auto text-end">
            <Link to={'/category-add'} className="btn btn-success"><FormattedMessage id="create_new_category" /></Link>
          </div>
        </div>
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: 'error_loading_data' }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: 'search_from_name' }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
      </PageLayout>
      <ToastDefault />
    </Fragment>
  );
}

export default Category;